// =========== plugin import ============= //
import {useState, useEffect, useRef} from 'react'
import axios from 'axios';
import Swal from 'sweetalert2';
// ================= component import ============== //
import AddProductFeatureAssociation from './component/AddProductFeatureAssociation';
import ProductFeatureAssociationSetupList from './component/ProductFeatureAssociationSetupList';
import ProductFeatureAssociationUpdateDrawer from './component/ProductFeatureAssociationUpdateDrawer';
import SideDrawer from '../../../../../../../../component/common/SideDrawer';
const ProductFeatureAssociationSetup = (props) => {
    const {
        formData, 
        formValidateError,
        productIsChange,
        featureIsChange,
        pfAssChange
    } = props;

    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    // ------ define all state ------- //
    const [ associatedUpdateId, setAssociatedUpdateId] = useState(-1);
    const [ associatedDataList, setAssociatedDataList ] = useState([]);
    const [ pfAssDrawerIsOpen, setpfAssDrawerIsOpen ] = useState(false);
    const [ updateAssociationData, setUpdateAssociationData ] = useState([]);
    const [pfAssociationIsChange, setPfAssociationIsChange] = useState(false);

    const associatedDateHandler = async (associatedData) => {
        setPfAssociationIsChange(true)
        if(Object.keys(associatedData).length > 0){
            if (!Array.isArray(associatedData.select_association)) {
                associatedData.select_association = [associatedData.select_association];
            }

            // ------ check duplicate action ------ //
            let isDupProductFeatureAssociationData = false
            let serviceSetupAction = false
            let informationAction = false
            
            const informationData = formData['step2'].others_form_setup
            if(informationData.length > 0){
                informationAction = informationData.some(
                    (data) => data.action_name.trim() === associatedData.action_name.trim()
                );
            }

            const productFeatureAssData = formData['step3'].product_features_association_data
            if(productFeatureAssData.length > 0){
                isDupProductFeatureAssociationData = productFeatureAssData.some(
                    (data) => data.action_name.trim() === associatedData.action_name.trim()
                );
            }

            const serviceData = formData['step4'].service_setup
            if(serviceData.length > 0){
                serviceSetupAction = serviceData.some(
                    (data) => data.action_name.trim() === associatedData.action_name.trim()
                );
            }

            if(associatedUpdateId < 0){
                // ---- insert ---- //
                if(isDupProductFeatureAssociationData || serviceSetupAction || informationAction){
                    await Swal.fire({
                        text: 'Duplicate action cannot be added !',
                        icon: 'error',
                        showCancelButton: true,
                        showConfirmButton : false,
                        cancelButtonText: 'OK',
                    });
                    return;
                }
                setAssociatedDataList((prevList) => [...prevList, associatedData]);
                props.onInputChange(
                    'step3',
                    'product_features_association_data',
                    [
                        ...(Array.isArray(formData['step3'].product_features_association_data) ? formData['step3'].product_features_association_data : []),
                        associatedData
                    ]
                );
            }
            else{
                // ----- update ----- //
                const updateAssociatedDataState = [...formData['step3'].product_features_association_data];
                if(updateAssociatedDataState[associatedUpdateId].action_name !== associatedData.action_name){
                    if(isDupProductFeatureAssociationData || serviceSetupAction || informationAction){
                        await Swal.fire({
                            text: 'Duplicate action cannot be added !',
                            icon: 'error',
                            showCancelButton: true,
                            showConfirmButton : false,
                            cancelButtonText: 'OK',
                        });
                        return;
                    }
                }
                if(associatedData.select_response_type.value !== 'static_response'){
                    associatedData.final_response = '';
                    associatedData.initial_response = '';
                    associatedData.fail_response = '';
                }

                if(associatedData.folow_up_details === 'opt_in'){
                    associatedData.closing_Utterance = '';
                    associatedData.feedback = '';
                }
                else if(associatedData.folow_up_details === 'closing_utterance'){
                    associatedData.affiram_or_deny = null;
                    associatedData.feedback = '';
                    associatedData.select_action = null;
                }
                else if(associatedData.folow_up_details === 'feedback'){
                    associatedData.closing_Utterance = '';
                    associatedData.affiram_or_deny = null;
                    associatedData.select_action = null;
                }
                if( associatedData.affiram_or_deny?.value === 'no'){
                    associatedData.select_action = null;
                }
                updateAssociatedDataState[associatedUpdateId] = associatedData;
                setAssociatedDataList(updateAssociatedDataState);
                props.onInputChange(
                    'step3',
                    'product_features_association_data',
                    updateAssociatedDataState
                );
                setpfAssDrawerIsOpen(false)
            }
            setAssociatedUpdateId(-1)
        }
    }

    const associationDataUpdateHandler = (index) => {
        setUpdateAssociationData([associatedDataList[index]])
        setAssociatedUpdateId(index)
        setpfAssDrawerIsOpen(true)
    }
     const associationDataDeleteHandler = (index) => {
        setPfAssociationIsChange(true)
        const updateAssociationList = [...associatedDataList];
        updateAssociationList.splice(index, 1);
        setAssociatedDataList(updateAssociationList);
        props.onInputChange(
            'step3',
            'product_features_association_data',
            updateAssociationList
        );
    }
    const associateListOnDropHandler = (rearrangeAssociateData) => {
        setPfAssociationIsChange(true)
        setAssociatedDataList(rearrangeAssociateData);
        props.onInputChange(
            'step3',
            'product_features_association_data',
            rearrangeAssociateData
        );
    }

    useEffect(() => {
        setPfAssociationIsChange(false)
        setAssociatedDataList(formData['step3'].product_features_association_data)
    },[formData['step3']]);

    const drawerOnCloseHandler = (drawerName) => {
        const drawerMap = {
            pf_ass_update_drawer: () => {
                setpfAssDrawerIsOpen(false);
                setAssociatedUpdateId(-1);
            }
        };
        if (drawerMap[drawerName]) {
            drawerMap[drawerName]();
        }
    }

    // --------- api call --------- //
    const formRef = useRef();
    useEffect(() => {
        const saveAssociate = async () => {
            if (
                !pfAssociationIsChange && 
                !productIsChange && 
                !featureIsChange &&
                !pfAssChange
            ) return;
            const saveAssociateData = async () => {
                let associateData = [];
                if (associatedDataList.length > 0) {
                    const indexAttribute = associatedDataList.map((associate, index) => ({
                        ...associate,
                        index,
                    }));
                    associateData = indexAttribute
                }
                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token')
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken')
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }
                let associateFormData = new FormData();
                associateFormData.append("action_type", 'product_feature_association_data');
                associateFormData.append("bot_id", formData.bot_id);
                associateFormData.append("step", "step3");
                associateFormData.append("data", JSON.stringify(associateData));
                associateFormData.append("sass_id", localStorage.getItem('sass_id'));
                associateFormData.append("user_type", localStorage.getItem('type'));
                associateFormData.append("user_name", loginUserType == 'SA' ? localStorage.getItem('system_username') : '');
                const apiHeaders = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "x-access-token": apiToken,
                    },
                };
                try {
                    await axios.post(`${api_base_url}api/save-bot-details`, associateFormData, apiHeaders)
                    .then(async (res) => {
                        if(res.data.status === 'success'){
                            associateFormData = new FormData();
                            setPfAssociationIsChange(false)
                            props.prAssRefresh(false)
                            formRef.current?.resetForm();
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                } catch (error) {
                    console.error("Error during save:", error);
                }
            }
            await saveAssociateData();
        }
        saveAssociate()
    },[
        associatedDataList, 
        productIsChange, 
        featureIsChange, 
        pfAssChange
    ])


    return (
        <>
            <div className="row border border-dashed border-gray-400 rounded p-5 mb-5">
                <div className="col-md-12">
                    <AddProductFeatureAssociation 
                        formValidateError = {formValidateError}
                        formData={formData}
                        associatedDate={associatedDateHandler}
                        updateAssociationData={updateAssociationData}
                        isInfoOpenHandler={props.isInfoOpenHandler}
                        ref={formRef}
                    />
                </div>
                <ProductFeatureAssociationSetupList
                    associatedDataList={associatedDataList}
                    associationDataUpdate={associationDataUpdateHandler}
                    associationDataDelete={associationDataDeleteHandler}
                    associateListOnDrop={associateListOnDropHandler}
                />
            </div>
            <SideDrawer
                title={'Data Update'}
                width={600}
                open={pfAssDrawerIsOpen}
                drawer_name={'pf_ass_update_drawer'}
                placement={'right'}
                closable={false}
                drawerOnClose={drawerOnCloseHandler}
            >
                <ProductFeatureAssociationUpdateDrawer
                    formValidateError = {formValidateError}
                    formData={formData}
                    associatedDate={associatedDateHandler}
                    updateAssociationData={updateAssociationData}
                    ref={formRef}
                />
            </SideDrawer>
        </>
    )
}

export default ProductFeatureAssociationSetup
